import React from 'react';
import { Download, Link2, Sheet, Loader2, ChevronRight } from 'lucide-react';

interface ActionCardProps {
  title: string;
  subtitle: string;
  icon: React.ReactNode;
  onClick: () => void;
  loading?: boolean;
  disabled?: boolean;
}

export function ActionCard({ title, subtitle, icon, onClick, loading = false, disabled = false }: ActionCardProps) {
  return (
    <button 
      onClick={onClick} 
      disabled={disabled || loading}
      className={`action-card group ${(disabled || loading) ? 'opacity-50 cursor-not-allowed' : 'hover:shadow-md hover:border-blue-300'}`}
    >
      <div className="action-card-content">
        <div className="action-card-icon">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : icon}
        </div>
        <div className="action-card-text">
          <div className="action-card-title">{title}</div>
          <div className="action-card-subtitle">{subtitle}</div>
        </div>
        {!loading && !disabled && (
          <ChevronRight className="h-4 w-4 text-gray-400 flex-shrink-0" />
        )}
      </div>
    </button>
  );
}

// Pre-configured action cards
export function ExportCSVCard({ onClick, loading, disabled }: { 
  onClick: () => void; 
  loading?: boolean; 
  disabled?: boolean; 
}) {
  return (
    <ActionCard
      title="Export CSV"
      subtitle="One file incl. UDF"
      icon={<Download className="h-4 w-4" />}
      onClick={onClick}
      loading={loading}
      disabled={disabled}
    />
  );
}

export function ConnectAPICard({ onClick, loading, disabled }: { 
  onClick: () => void; 
  loading?: boolean; 
  disabled?: boolean; 
}) {
  return (
    <ActionCard
      title="Connect to API"
      subtitle="Send normalized JSON"
      icon={<Link2 className="h-4 w-4" />}
      onClick={onClick}
      loading={loading}
      disabled={disabled}
    />
  );
}

export function ConnectGoogleSheetsCard({ onClick, loading, disabled }: { 
  onClick: () => void; 
  loading?: boolean; 
  disabled?: boolean; 
}) {
  return (
    <ActionCard
      title="Connect to Google Sheet"
      subtitle="Sync columns"
      icon={<Sheet className="h-4 w-4" />}
      onClick={onClick}
      loading={loading}
      disabled={disabled}
    />
  );
}
